export function getTypeAlias(type) {
    return type === 'email' ? 'Email' : '手机号';
}
